(() => {
  if (customElements.get('ts-charge-chart')) return;
  customElements.define('ts-charge-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const filters = this.querySelector('.ts-charge__filters');
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('button[data-family]');
        if (!button || !filters.contains(button)) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-device-family]').forEach(row => {
          row.hidden = button.dataset.family !== 'all' && row.dataset.deviceFamily !== button.dataset.family;
        });
      });
      const revealCurrent = () => {
        const scroller = this.querySelector('.ts-charge__scroll');
        const current = this.querySelector('thead .is-current');
        const label = this.querySelector('thead th');
        if (!scroller || !current || !scroller.clientWidth) return false;
        if (scroller.scrollWidth > scroller.clientWidth) {
          scroller.scrollLeft = Math.max(0, current.offsetLeft - label.offsetWidth);
        }
        return true;
      };
      requestAnimationFrame(() => {
        if (revealCurrent()) return;
        this.visibilityObserver = new ResizeObserver(() => {
          if (revealCurrent()) { this.visibilityObserver.disconnect(); this.visibilityObserver = null; }
        });
        this.visibilityObserver.observe(this);
      });
    }
    disconnectedCallback() { this.visibilityObserver?.disconnect(); }
  });
})();
